import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, mergeProps as _mergeProps, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode } from "vue"

import { useField } from "vee-validate";
import { useAttrs, toRef } from "vue";
import { InputOption } from "@/core/data/interfaces";


export default /*#__PURE__*/_defineComponent({
  __name: 'AbitSelect',
  props: {
    name: {},
    label: {},
    placeholder: {},
    horizontal: { type: [String, Boolean] },
    required: { type: Boolean },
    options: {},
    wrapperClass: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const emitInput = __emit;

const props = __props;

const options = toRef(props, "options");

const handleChange = (newValue: string) => {
    value.value = newValue;
    emitInput("update:modelValue", newValue);
};

const attrs = useAttrs();

const { value, errorMessage } = useField<string>(props.name);

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
            props.wrapperClass || 'a',
            props.horizontal && 'horizontal-wrapper',
        ])
  }, [
    (props.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          class: _normalizeClass([
                'form-label',
                props.required && 'required',
                props.horizontal && 'horizontal',
            ])
        }, _toDisplayString(props.label), 3))
      : _createCommentVNode("", true),
    _createVNode(_component_el_form_item, {
      class: _normalizeClass(props.horizontal ? 'form-item-horizontal' : ''),
      error: _unref(errorMessage),
      validateStatus: _unref(errorMessage) ? 'error' : 'success'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_select, _mergeProps({
          "model-value": _unref(value),
          onChange: handleChange,
          placeholder: props.placeholder,
          name: props.name,
          as: "select",
          "fit-input-width": false,
          style: {"width":"100%"}
        }, _unref(attrs)), _createSlots({
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                value: item.id,
                label: item.name,
                key: item.id
              }, null, 8, ["value", "label"]))
            }), 128))
          ]),
          _: 2
        }, [
          (_ctx.$slots.prefix)
            ? {
                name: "prefix",
                fn: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "prefix")
                ]),
                key: "0"
              }
            : undefined
        ]), 1040, ["model-value", "placeholder", "name"])
      ]),
      _: 3
    }, 8, ["class", "error", "validateStatus"])
  ], 2))
}
}

})